<template>
    <div>
        <div>
            <el-form ref="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm"
                     :model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm" label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="年级">
                            <el-select v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.grade_id"
                                       filterable placeholder="请选择"
                                       style="width: 130px!important;">
                                <el-option
                                        v-for="item in $parentInfo.initInformation.grades"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="学科">
                            <el-select v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.subject_id"
                                       multiple placeholder="请选择"
                                       style="width: 130px!important;">
                                <el-option
                                        v-for="item in $parentInfo.initInformation.subjects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin: 0 0 15px 0">
                    <el-col :span="20">
                        <el-radio v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.classType_id"
                                  label="1">一对一
                        </el-radio>
                        <el-radio v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.classType_id"
                                  label="2">一对三
                        </el-radio>
                        <el-radio v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.classType_id"
                                  label="3">小班
                        </el-radio>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col align="left" :span="24">
                        <el-form-item label="咨询详情">
                            <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入内容"
                                    v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.content">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="印象分">
                            <el-rate v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.impression"
                                     show-score text-color="#ff9900"></el-rate>
                            <!--<el-input v-model="insertForm.impression" placeholder="请输入印象分"></el-input>-->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="15">
                        <el-form-item label="状态">
                            <el-select v-model="$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.status"
                                       filterable placeholder="咨询"
                                       :disabled=$parentInfo.studentAdvisory.dialog_AddAdvisory.isDisabled>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreAdvisory()"
                       :loading="$parentInfo.studentAdvisory.dialog_AddAdvisory.button_loading">保存
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_AddAdvisory",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm = {
                impression: '',
                grade_id: '',
                subject_id: [],
                classType_id: '',
                content: '',
                status: ''
            };
        },
        methods: {
            //年级,学科信息
            handleStoreAdvisory() {
                this.$parentInfo.studentAdvisory.dialog_AddAdvisory.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'storeAdvisory', {
                    'student_id': this.$parentInfo.student_id,
                    'content': this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.content,
                    'subject_id': this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.subject_id,
                    'grade_id': this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.grade_id,
                    'impression': this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.impression,
                    'classType_id': this.$parentInfo.studentAdvisory.dialog_AddAdvisory.insertForm.classType_id,

                });
            },
        }
    }
</script>

<style scoped>
    .el-select {
        width: 100% !important;
    }
</style>
